import styled from "styled-components";

const Bar = styled.footer`
  background: var(--color-primary-dark);
  color: #d1d5db;
  margin-top: 3rem;
`;

const Inner = styled.div`
  max-width: var(--max-width);
  margin: 0 auto;
  padding: 1.5rem 1.25rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 1rem;
  font-size: 0.9rem;
`;

function Footer() {
  return (
    <Bar>
      <Inner>
        <span>Blue Skies and Sunsets. -Robert Durbin</span>
      </Inner>
    </Bar>
  );
}

export default Footer;
